import { Component } from '@angular/core';

@Component({
  selector: 'app-donor-list',
  templateUrl: './donor-list.component.html',
  styleUrl: './donor-list.component.scss'
})
export class DonorListComponent {

}
